export const BREAKPOINT_SM = 'only screen and (max-width : 40rem)';
